import React from 'react';
import { MainLayout } from '@/components/layout/MainLayout';
import { EntityProjectBrowser } from '@/components/entity/EntityProjectBrowser';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { TreePine, MapPin, Eye } from 'lucide-react';

const ProjectSearchProjects = () => {
  return (
    <MainLayout>
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">Project Developer - Search Projects</h1>
          <p className="text-muted-foreground">
            Browse and view detailed information about carbon offset projects from verified registries
          </p>
          <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-blue-800 text-sm">
              <strong>Project Developer View:</strong> You can browse and view project details but cannot purchase credits. 
              Use this to research market trends and competitor projects.
            </p>
          </div>
        </div>

        {/* Custom Project Browser for Project Developers */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <TreePine className="w-5 h-5" />
              Available Projects - Research & Analysis
            </CardTitle>
          </CardHeader>
          <CardContent>
            <EntityProjectBrowser />
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default ProjectSearchProjects;